import { ServiceTypeEnum } from '@/constants/enums';

export const ServiceTypeConfig = {
    [ServiceTypeEnum.PERIODIC_SERVICE]: 'periodic_maintenance',
    [ServiceTypeEnum.SPECIFIC_REPAIR]: 'specific_repair',
    [ServiceTypeEnum.NOT_SURE_ABOUT_ISSUE]: 'yet_to_be_decided',
    [ServiceTypeEnum.CAR_SPA_AND_CLEANING]: 'car_spa_and_cleaning',
};
